import * as React from 'react'
import { compose, pure } from 'recompose'

import QuestionEntity from '../../../../commons/entity/QuestionEntity'

import QuestionTitle from '../../molecules/QuestionTitle/QuestionTitle'
import QuestionChoiceSet from '../../organisms/QuestionChoiceSet/QuestionChoiceSet'

import { TIMEOUT } from '../../../../commons/QuizPhase'
import * as styles from './Question.css'

interface QuestionProps {
  isEnabled?: boolean
  isHidden?: boolean
  time?: number
  question: QuestionEntity
  phase: number
  answerChoiceId?: number
  answerCount?: { [key: string]: number }
  postAnswer: (data: any) => void
}

const Question: React.FunctionComponent<QuestionProps> = ({
  question,
  time,
  phase,
  answerChoiceId,
  answerCount,
  postAnswer,
  isEnabled = true,
  isHidden = false
}) => {
  if (!question) {
    return <div />
  }
  return (
    <div className={styles.question}>
      <div className={styles.questionTitle}>
        <QuestionTitle title={question.title} time={phase >= TIMEOUT ? 0 : time} limit_time={question.limit_time} />
      </div>
      {isHidden ? null : (
        <div className={styles.choiceSet}>
          <QuestionChoiceSet
            isEnabled={isEnabled}
            question={question}
            answerChoiceId={answerChoiceId}
            answerCount={answerCount}
            postAnswer={postAnswer}
          />
        </div>
      )}
    </div>
  )
}

export default compose<QuestionProps, QuestionProps>(pure)(Question)
